<script lang="ts">
  import ChatComposer from '../hud/ChatComposer.svelte';
  import { LOBBY_UI } from '../../game/constants/lobby';
  import { UNNAMED_NAME } from '../../game/constants/world';
  import { isSystemChat, type ChatLine } from '../../game/world';

  interface Props {
    lines: readonly ChatLine[];
    onsend: (text: string) => void;
  }

  const { lines, onsend }: Props = $props();

  let log = $state<HTMLOListElement | null>(null);

  $effect(() => {
    void lines.length;
    if (log !== null) log.scrollTop = log.scrollHeight;
  });

  function inkOf(team: number): string {
    return LOBBY_UI.teamInk[team] ?? '#97a0b6';
  }

  const isSystem = isSystemChat;
</script>

<section class="chat" data-testid="lobby-chat">
  <h3 class="chat__heading">Chat</h3>
  <ol class="chat__log" bind:this={log} data-testid="lobby-chat-log">
    {#each lines as line, index (index)}
      <li class="chat__line" class:chat__line--system={isSystem(line)}>
        {#if !isSystem(line)}
          <span class="chat__sender" style:color={inkOf(line.team)}
            >{line.sender === '' ? UNNAMED_NAME : line.sender}</span
          >
        {/if}
        <span class="chat__text">{line.text}</span>
      </li>
    {:else}
      <li class="chat__line chat__line--empty">Nobody has said anything yet</li>
    {/each}
  </ol>
  <ChatComposer {onsend} />
</section>

<style>
  .chat {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
  }

  .chat__heading {
    margin: 0 0 6px;
    font-size: 11px;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #97a0b6;
  }

  .chat__log {
    flex: 1 1 auto;
    min-height: 0;
    margin: 0 0 8px;
    padding: 0;
    overflow-y: auto;
    list-style: none;
  }

  .chat__line {
    display: flex;
    gap: 6px;
    padding: 1px 0;
    font-size: 12px;
    line-height: 1.35;
    color: #dfe6f5;
  }

  .chat__line--empty,
  .chat__line--system {
    color: #97a0b6;
    font-style: italic;
  }

  .chat__sender {
    flex: 0 0 auto;
    font-weight: 700;
    unicode-bidi: isolate;
  }

  .chat__text {
    flex: 1 1 auto;
    min-width: 0;
    overflow-wrap: anywhere;
  }
</style>
